/** Links shared by the signed-out pages (home and /features). */
export const INQUIRE_URL = "https://acuitysis.com/onboarding";

/**
 * The guided demo (signed-in users with course builder access).
 * Everyone else is offered "Request a demo" (the inquiry form) instead.
 */
export const DEMO_PATH = "/features/demo";

/** The course the demo shows, read-only: "Algebra 1 (Demo Version)" in School 1 (Demo). */
export const DEMO_COURSE_ID = "40392244-237e-4c3b-bfb5-5085762c8dad";
